import  React, {Component} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import DashboardPage from './config/navigation/DashboardPage';
import LoginPage from './screens/modules/security/LoginPage';
import LoginPage2 from './screens/modules/security/LoginPage2';
import AlertPage from './screens/modules/security/AlertPage';
import {login} from './config/redux/actions/securityActions';
import {connect} from 'react-redux'
import {withStyles} from '@material-ui/core/styles';
import 'animate.css';

class App extends Component {
    constructor(props){
        super(props);
    }

    componentWillMount(){
        const data = JSON.parse(sessionStorage.getItem('security'));
        if(data != null) this.props.login(data, null);
    }

    render(){
        return(
            <Router>
                <div>
                    <Switch>
                        <Route exact path={'/cartillas'} render={(props) => {
                            return(this.props.isLogin)?<DashboardPage {...props}/>:<LoginPage {...props}/>;
                        }}>
                        </Route>
                        <Route exact path={'/cartillas/citas'} render={(props) => {
                            return(this.props.isLogin)?<DashboardPage {...props}/>:<LoginPage2 {...props}/>;
                        }}>
                        </Route>
                        <Route exact path={'/citas'} render={(props) => {
                            return(this.props.isLogin)?<LoginPage2 {...props}/>:<LoginPage2 {...props}/>;
                        }}>
                          
                        </Route>
                        <Route path={'/'} render={(props) => {
                            return<LoginPage2 {...props}/>;
                        }}></Route>
                        <Route path={"*"} component={() => {
                            return(
                                <AlertPage code={"404"}
                                codeDesc={"Not Found"}
                                title={"Página no encontrada."}
                                message={"La página que está solicitando no existe, por favor verifique la URL."} />
                            );
                        }}/>
                    </Switch>
                </div>
            </Router>
        );
    }

}

const styles = {
    
};

const mapStateToProps = (state, props) => {
    return {
        isLogin: state.security.isLogin
    };
};
const mapDispatchToProps = {
    login
};
export default connect(mapStateToProps, mapDispatchToProps)(App);